import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Returns.frontend.types'

@Injectable({ providedIn: 'root' })
export class Returns_get_blind_return_new_lot_statusService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { manufactureDate?: string, expirationDate?: string, lookupcode?: string, materialId?: number }): Promise<{ recommendedStatusId?: number, reasons?: string[], isMandatory?: boolean }> 
  {
    let url = `${environment.backendUrl}api/Returns/functions/get_blind_return_new_lot_status`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

